
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Ja. <Link href='https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/2765641' mdxType="Link">Studien</Link> zeigen, am infektiösesten sind Infizierte direkt vor dem Auftreten
  der Symptome. Forscher der Universität Bern kamen nach der <Link href='https://www.medrxiv.org/content/10.1101/2020.04.25.20079103v2' mdxType="Link">Sichtung</Link> von
  zahlreichen Wissenschaftsarbeiten zum Schluss, dass 40 bis 60% aller
  Ansteckungen von Personen kommen, die erst nach der Weitergabe des Virus
  Symptome zeigen. Wenn ein Infizierter in diesem Zeitfenster in ein Restaurant,
  eine Bar, einen Fitnessclub oder einfach zur Arbeit geht, besteht für seine
  Umgebung ein hohes Infektionsrisiko.
    </p>
    <p>
  Wie viele Tage vor Krankheitsbeginn man ansteckend ist, <Link href='https://smw.ch/article/doi/smw.2020.20336' mdxType="Link">berechneten</Link> Forscher
  um den ETH-Professor Sebastian Bonhoeffer. Das Resultat: Bis zu 5 Tage vor
  Krankheitsausbruch sind Infizierte ansteckend. Die höchste Infektiosität
  verzeichnet man kurz vor Symptombeginn. Nur 5 Tage später stellt ein
  Infizierter kaum noch eine Gefahr dar.
    </p>
    <Image className='cbImage' file={browserCheck.isMobile ? require('images/infektiositaet-mobile.svg') : require('images/infektiositaet.svg')} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;